export function required(val) {
  if (!val) return false;
  const v = String(val);
  return v.trim().length > 0;
}
export function ICOValidator(val) {
  val = val.replace(/ /g, '');
  const reg = new RegExp('(^\\d{6}$)|(^\\d{8}$)');
  if (!reg.test(val)) {
    return false;
  }
  if (val.length === 6) {
    val = `00${val}`;
  }
  let a = 0;
  for (let i = 0; i < 7; i += 1) {
    a += parseInt(val[i], 10) * (8 - i);
  }
  a %= 11;
  let c = 11 - a;
  if (a === 0) c = 1;
  if (a === 1) c = 0;
  return parseInt(val[7], 10) === c;
}
export function contractValidator(val) {
  val = val.replace(/ /g, '');
  const reg = new RegExp('(^7\\d{7}$)|(^\\d{10}$)');
  return reg.test(val);
}
export function odometerReadingValidator(val) {
  if (typeof val !== 'string') return false;
  let isValid = true;
  if (/^[0-9]+$/.test(val)) {
    if (parseInt(val, 10) < 1 || parseInt(val, 10) > 9999999) {
      isValid = false;
    }
  } else {
    isValid = false;
  }
  return isValid;
}
export function emailValidator(val) {
  // const matchPat = /^[a-zA-Z0-9_\\.\\-]{1,2000}@[a-zA-Z0-9\\-]+(\\.[a-zA-Z0-9\\-]{1,200}){0,10}[a-zA-Z0-9\\-]?\\.[a-zA-Z0-9\\-]{2,60}$/;
  // const matchNoHyphen = /^[^@]*@((?!-)[^\\.]*[^-])(\\.(?!-)[^\\.]*[^-])*$/;
  // return matchPat.test(String(val).toLowerCase()) && matchNoHyphen.test(String(val).toLowerCase());
  const re = /^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/;
  return re.test(val);
}
